    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:7881/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

export async function createRegistration() {
  const response = await fetch(
    `${API_URL}/registration`,
    {
      method: "POST",
    }
  );

  return response.json();
}

export async function getRegistration(
  registrationCode: string
) {
  const response = await fetch(
    `${API_URL}/registration/${registrationCode}`
  );

  return response.json();
}